import useFCMTokenUpdater from './useFCMTokenUpdater';
import useForegroundMessageHandler from './useForegroundMessageHandler';
import useNotificationPermission from './useNotificationPermission';
export default function useNotifications() {
    const [notificationPermissionGranted] = useNotificationPermission();
    useFCMTokenUpdater(notificationPermissionGranted);
    useForegroundMessageHandler();
}
